registerComponent("sections/slider-videos", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow` / `slidesToScroll` iguais ao
 * `data-number-slides`, `4` quando ele não vem, `1` a partir do
 * `breakpoint: 767`, `infinite: false`) vira um `Asa.trilho`. O passo continua
 * sendo a JANELA inteira (`passo: 'pagina'`), e quantos cabem por janela quem
 * diz é o CSS — o trilho MEDE, não recebe.
 *
 * ⚠️ `data-number-slides` é prop pública deste componente e a única coisa que
 * o CSS não tem como saber sozinho: o valor vai para o trilho como
 * `--itens-por-janela`, que a folha usa na largura do cartão. O default mora
 * nos DOIS lados (`4` aqui e no `_slider-videos.less`), como em 2020, e o
 * `Asa.trilho` continua medindo — o custom property não manda nele.
 *
 * ⚠️ ESTE COMPONENTE NÃO RENDERIZA EM NENHUMA URL: não há um único call site no
 * repositório (`UnreferencedComponentsTest`). O que prova este arquivo é o
 * `yarn lint`, o `node --check` do bundle e o grep de dependência legada.
 * Candidato ao protocolo de remoção da Fase 9, junto de `sections/home-videos`,
 * `sections/home-insights`, `modals/modal-contact`, `pages/help` e
 * `pages/wealth-planning`.
 *
 * O `console.log(numberSlides)` de 2020 saiu.
 */

const lista = component.querySelector('.slider');

if (lista) {
    const itensPorJanela = parseInt(component.dataset.numberSlides, 10);

    if (itensPorJanela > 0) {
        lista.style.setProperty('--itens-por-janela', String(itensPorJanela));
    }

    Asa.trilho(lista, Object.assign(
        { itens: ':scope > .card-video', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
    ));
}

});
